import { useTranslation } from 'react-i18next';
import { Menu } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import { useUiStore } from '@/store/uiStore';
import { BranchSwitcher } from './BranchSwitcher';
import { LanguageSwitcher } from './LanguageSwitcher';
import { NotificationMenu } from './NotificationMenu';
import { UserMenu } from './UserMenu';

export function Header() {
  const { t } = useTranslation();
  const tenant = useAuthStore((state) => state.user?.tenant);
  const setMobileNavOpen = useUiStore((state) => state.setMobileNavOpen);

  return (
    <header className="border-line sticky top-0 z-20 flex h-16 items-center gap-3 border-b bg-white px-4 lg:px-6">
      <button
        type="button"
        className="text-muted hover:text-ink shrink-0 lg:hidden"
        aria-label={t('common.openNavigation')}
        onClick={() => setMobileNavOpen(true)}
      >
        <Menu className="size-5" aria-hidden />
      </button>

      <div className="min-w-0 flex-1">
        {tenant ? (
          <>
            <p className="text-ink truncate text-sm font-semibold">{tenant.name}</p>
            <p className="text-muted truncate text-xs">{tenant.code}</p>
          </>
        ) : (
          <p className="text-muted truncate text-sm font-medium">{t('nav.sections.platform')}</p>
        )}
      </div>

      <div className="flex shrink-0 items-center gap-2 sm:gap-3">
        <BranchSwitcher />
        <NotificationMenu />
        <LanguageSwitcher />
        <UserMenu />
      </div>
    </header>
  );
}
